import { render, staticRenderFns } from "./AnoComponent.vue?vue&type=template&id=5bc21d2a"
import script from "./AnoComponent.vue?vue&type=script&lang=js"
export * from "./AnoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports